@if (isPrint || !isMobileVersion) {
  <div
    [ngClass]="{
      'h-full': fullHeight
    }"
  >
    <ng-content select="[slot=desktop]"></ng-content>
  </div>
}
@if (!isPrint && isMobileVersion) {
  <div class="-mx-xl {{ extraMobileClass }}">
    <ng-content select="[slot=mobile]"></ng-content>
  </div>
}
